import { elementTypes } from './configs/ElementTypes'
import { TextElement } from './TextElement'
import { ImageElement } from './ImageElement'
import ButtonElement from './ButtonElement'
import IframeElement from './IframeElement'
import VideoElement from './VideoElement'
import { BoxElement } from './BoxElement'
import { ShapeElement } from './ShapeElement'
import { PagesResource } from '@/resources/index'
import {
  defaultElementStyles,
  donwloadUsedFonts
} from './configs/ElementsConfig'
import { downloadFullFont, setCustomFonts } from '../FontManager/fontDownload'

import Image from '@/assets/images/elements/image.svg'

const isMobile = require('ismobilejs')

const components = {
  [elementTypes.DEFAULT]: null,
  [elementTypes.TEXT]: TextElement,
  [elementTypes.IMAGE]: ImageElement,
  [elementTypes.BUTTON]: ButtonElement,
  [elementTypes.SQUARE]: BoxElement,
  [elementTypes.RHOMBUS]: ShapeElement,
  [elementTypes.CIRCLE]: BoxElement,
  [elementTypes.LINE]: BoxElement,
  [elementTypes.TRIANGLE]: ShapeElement,
  [elementTypes.ARROW]: ShapeElement,
  [elementTypes.STAR]: ShapeElement,
  [elementTypes.IFRAME]: IframeElement,
  [elementTypes.VIDEO]: VideoElement
}

const tags = {
  [elementTypes.TEXT]: 'div',
  [elementTypes.IMAGE]: 'img',
  [elementTypes.BUTTON]: 'button',
  [elementTypes.SQUARE]: 'div',
  [elementTypes.RHOMBUS]: 'svg',
  [elementTypes.CIRCLE]: 'div',
  [elementTypes.LINE]: 'div',
  [elementTypes.TRIANGLE]: 'svg',
  [elementTypes.ARROW]: 'svg',
  [elementTypes.STAR]: 'svg',
  [elementTypes.IFRAME]: 'iframe',
  [elementTypes.VIDEO]: 'iframe'
}

export const EditorFactory = type => {
  return components[type] || null
}

/**
 * Create a empty object
 * @param {ElementType} type
 */
export const createEmptyObject = async (type, pageID, zIndex) => {
  const config = defaultElementStyles[type]
  config.styles.zIndex = zIndex
  const payload = {
    elementType: type,
    ...config
  }
  try {
    const { data } = await PagesResource.savePageItem(pageID, {
      content: JSON.stringify(payload),
      position: zIndex
    })
    return data
  } catch (err) {
    console.log(err)
  }
  return null
}

const applyScaleFactor = (styles, attributes, tag, scaleFactor, type) => {
  Object.keys(styles).map(key => {
    let value = styles[key]

    if (typeof value === 'string' && value.indexOf('px') !== -1) {
      if (key === 'boxShadow' || key === 'textShadow') {
        value = threatShadow(value, scaleFactor)
      } else if (key === 'filter') {
      } else if (key === 'lineHeight') {
        value = `${(+value.replace(/px/, '') * scaleFactor).toFixed(0)}px`
      } else {
        value = `${+value.replace(/px/, '') * scaleFactor}px`
      }
    }

    /**
     * BUG FIX - FONTSIZE PHONE APPLE
     */
    if (key === 'fontSize' && isMobile.apple.phone) {
      let fontSizeValue = +value.replace(/px/, '')
      if (fontSizeValue > 15) tag.style['letter-spacing'] = '-1px'
    }

    tag.style[key] = value
    return key
  })

  Object.keys(attributes).map(key => {
    let value = attributes[key]
    if (typeof value === 'string' && value.indexOf('px') !== -1) {
      value = `${+value.replace(/px/, '') * scaleFactor}px`
    }
    tag.style[key] = value
    return key
  })

  if (type === 'text') {
    const regex = /\bfont-size:\s\S+px\b/gi
    const matchs = tag.innerHTML.match(regex)
    if (!matchs) {
      return
    }
    matchs.map(match => {
      const num = match.match(/\d{1,3}/gi)[0]
      const newValue = match.replace(/\d{1,3}/gi, +num * scaleFactor)

      tag.innerHTML = tag.innerHTML.replace(match, newValue)
      return match
    })
  }
}

export const rawElementFactory = (
  content,
  scaleFactor = null,
  downloadFonts = false,
  mode
) => {
  const { styles, attributes, elementType, link, fontFamilyMap } = content

  let tag = createTag(elementType, content, mode)

  if (elementType === 'text') {
    // template replace for already texts created
    tag.innerHTML = content.html
      ? content.html.replace(/<p>/, '<div>').replace(/<\/p>/, '</div>')
      : ''
    tag.style.wordBreak = 'break-word'
    //delete styles['fontFamily']
    //delete styles['fontSize']
  }

  if (downloadFonts) {
    const fontFamily = styles['fontFamily']
    const fontPath = styles['fontPath']
    if (fontPath) {
      setCustomFonts(fontFamily, fontPath)
    }
    if (fontFamily && !fontPath) {
      downloadFullFont(fontFamily, `${fontFamily.replace(' ', '')}`, ['normal'])
    }
    if (elementType === 'text' && !fontPath) {
      donwloadUsedFonts(fontFamilyMap)
    }
  }

  if (scaleFactor) {
    applyScaleFactor(styles, attributes, tag, scaleFactor, elementType)
  } else {
    Object.keys(styles).map(key => (tag.style[key] = styles[key]))
    Object.keys(attributes).map(key => (tag.style[key] = attributes[key]))
  }

  if (elementType === 'iframe') {
    handleIframe(tag, content.content, mode)
  }

  if (elementType === 'video') {
    handleVideo(tag, content, mode)
  }

  if (!!link)
    tag = mode === 'pdf' ? createLinkPDF(tag, link) : createLinkMagazine(tag, link)

  return tag.outerHTML
}

/**
 * 
 * @param {String} elementType
 * @param {Object} content 
 * @param {String} mode 
 */
const createTag = (elementType, content, mode) => {
  const tagType = tags[elementType]
  let tag = ''

  if (elementType === 'rhombus' || elementType === 'triangle') {
    const { attrShape, viewBox, styles } = content

    tag = document.createElement('img')
    const tagSVG = createElementSVG(tagType, { viewBox })

    let useSVG = ''
    for (let attr in attrShape) {
      useSVG = createElementSVG(attr, attrShape[attr])
    }

    tagSVG.appendChild(useSVG)
    handleStylesSVG(styles, tagSVG)
    tag.src = convertSVGtoBase64(tagSVG)
  }
  else if (elementType === 'iframe' && mode === 'pdf') {
    tag = document.createElement('div')
  }
  else if (elementType === 'video' && mode === 'pdf') {
    tag = document.createElement('div')
  }
  else if (elementType === 'image') {
    const { attributes } = content

    tag = document.createElement('img')
    tag.src = attributes.src || Image
    tag.alt = content.text
  }
  else {
    tag = document.createElement(tagType)
  }

  tag.style.position = 'absolute'

  return tag
}

/**
 * Handle video in publish and PDF
 * @param {Element} tag 
 * @param {Object} content 
 * @param {String} mode 
 */
const handleVideo = (tag, content, mode) => {
  if (mode === 'pdf') {
    const { src } = content

    tag.style['background-image'] = `url(${src.image})`
    tag.style['background-size'] = '100% 100%'

  } else {
    const { src, options } = content

    src.video += '?'

    if (options.time.enabled) {
      const { start, end } = options.time
      src.video += `&start=${start}&end=${end}`
    }

    if (options.autoplay) {
      src.video += `&autoplay=${1}`
    }

    if (options.noControls) {
      src.video += `&controls=${0}`
    }

    if (options.loop) {
      if (src.platform === 'wistia') {
        src.video += '&endVideoBehavior=loop'
      } else {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/
        const match = src.video.match(regExp)

        src.video += `&loop=${1}`

        /* Loop from youtube */
        if (match && match[2]) {
          src.video += `&playlist=${match[2]}`
        }

      }
    }

    tag.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture')
    tag.src = src.video
  }

  return tag
}

/**
 * Handle iframe in publish and PDF
 * @param {Element} tag 
 * @param {Object} content 
 * @param {String} mode 
 */
const handleIframe = (tag, content, mode) => {
  if (mode === 'pdf') {

    if (!!content.embedURL || !!content.embedDocument) {
      const { src } = content

      tag.style['background-image'] = `url(${src})`
      tag.style['background-size'] = '100% 100%'
    }

  } else {

    if (!!content.embedURL) {
      tag.src = content.embedURL
    }
    if (!!content.embedDocument) {
      const html = `<html>
        <head>
          <style>
            body{ margin: 0; width: 100vw; height: 100vh} 
            iframe { width: 100%; height: 100%; }
          </style>
        </head>${content.embedDocument}</html>`

      tag.srcdoc = html
    }
  }

  return tag
}

/**
 * Return the scaled box shadow
 * @param {String} value
 * @param {Number} factor
 */
const threatShadow = (value, factor) => {
  const v = value.split(/px\s/g)
  return `${v[0] * factor}px ${v[1] * factor}px ${v[2] * factor}px ${v[3]}`
}

/**
 * Create link element in PDF
 * @param {Element} tag
 * @param {Object} link
 */
const createLinkPDF = (tag, link) => {
  const styleLink = {
    position: 'absolute',
    width: tag.style.width,
    height: tag.style.height,
    left: tag.style.left,
    top: tag.style.top
  }
  const tagDiv = document.createElement('div')
  let tagLink = document.createElement('a')

  if (link.url) {
    tagLink.href = link.url
    tagLink.target = link.target
  } else if (link.page) {
    tagLink.href = `#page-${link.page}`
  }

  //Set css in tag <a>
  for (let prop in styleLink) tagLink.style[prop] = styleLink[prop]

  tagDiv.appendChild(tag)
  tagDiv.appendChild(tagLink)

  return tagDiv
}

/**
 * Create element of link
 * @param {Element} tag
 * @param {Object} link
 */
const createLinkMagazine = (tag, link) => {

  let tagLink = document.createElement('a')

  if (link.url) {
    tagLink.href = link.url
    tagLink.target = link.target
    tagLink.appendChild(tag)
    return tagLink

  } else if (link.page) {
    tagLink.href = `#page-${link.page}`
    tagLink.appendChild(tag)
    return tagLink
  }

  return tag
}

/**
 * Create element SVG
 * @param {Element} element
 * @param {Object} value
 */
const createElementSVG = (element, value) => {
  element = document.createElementNS('http://www.w3.org/2000/svg', element)
  for (var prop in value) element.setAttribute(prop, value[prop])
  return element
}

/**
 * Covert element SVG to BASE64
 * @param {Element} toSVG
 */
const convertSVGtoBase64 = toSVG => {
  let svg = new XMLSerializer().serializeToString(toSVG)
  let svgToBase64 = 'data:image/svg+xml;base64,' + btoa(svg)
  return svgToBase64
}

/**
 * Apply styles in SVG
 * @param {Object} styles
 * @param {Element} tag
 */
const handleStylesSVG = async (styles, tag) => {
  Object.keys(styles).map(key => {
    let value = styles[key]
    if (key === 'fill') {
      tag.setAttribute(key, value)
    }
    return key
  })
}



// WEBPACK FOOTER //
// ./src/components/commons/editor/EditorFactory.js